import { IconWrapper } from '../runtime';
export default IconWrapper('rocket', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 48 48"
    }
  }, [h("g", {
    "attrs": {
      "stroke": "none",
      "stroke-width": props.strokeWidth,
      "fill": "none",
      "fill-rule": "evenodd",
      "stroke-linejoin": props.strokeLinejoin
    }
  }, [h("g", {
    "attrs": {
      "transform": "translate(7.000000, 4.000000)",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.7050001,3.89449161 L17,0 L22.2949999,3.89449161 C25.8819274,6.53268984 28,10.7198227 28,15.172478 L28,33 L6,33 L6,15.172478 C6,10.7198227 8.11807256,6.53268984 11.7050001,3.89449161 Z",
      "fill": props.colors[1],
      "fill-rule": "nonzero"
    }
  }), h("polygon", {
    "attrs": {
      "stroke-linecap": props.strokeLinecap,
      "points": "6 13 -2.83106871e-14 19 -2.83106871e-14 27 6 24"
    }
  }), h("polygon", {
    "attrs": {
      "stroke-linecap": props.strokeLinecap,
      "points": "28 13 34 19 34 27 28 24"
    }
  }), h("path", {
    "attrs": {
      "d": "M11,35 L11,38",
      "stroke-linecap": props.strokeLinecap
    }
  }), h("path", {
    "attrs": {
      "d": "M17,35 L17,40",
      "stroke-linecap": props.strokeLinecap
    }
  }), h("path", {
    "attrs": {
      "d": "M23,35 L23,38",
      "stroke-linecap": props.strokeLinecap
    }
  })])])]);
});